import React from 'react';
import Icon from '~react/components/FilterList/components/Icon';
import { BasicObject } from '~components/ObjectHelper';
import { encodeQueryData } from '~utils/url';
import { z } from 'zod';

export const actionItemSchema = z.object({
    icon: z.string(),
    label: z.string(),
    url: z.string(),
    addFilters: z.boolean(),
});

export type ActionData = z.infer<typeof actionItemSchema>;

interface ActionProps {
    actions: ActionData[];
    filter: BasicObject;
}

const Actions: React.FC<ActionProps> = props => {
    const actions = props.actions.map((action, index) => {
        let url = action.url;
        if (action.addFilters) {
            url += '?' + encodeQueryData(props.filter);
        }
        return (
            <a href={url} className="btn -with-icon -secondary" key={index}>
                <Icon type={action.icon} />
                <span>{action.label}</span>
            </a>
        );
    });
    return <div className="actions">{actions}</div>;
};

export default Actions;
